import React from 'react';
import _ from 'lodash';

interface AssetGroupCellDebugProps {
  formula: string;
  parameters: { item: { id: string } }[];
}

export const AssetGroupCellDebug: React.FunctionComponent<AssetGroupCellDebugProps> = ({ formula, parameters }) => (
  <div className="flexRowContainer">
    <span>{formula}</span>
    <br />
    {_.map(parameters, (param) => (
      <span key={`debugParam_${param?.item?.id}`}>{param?.item?.id}</span>
    ))}
  </div>
);
